import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'Context/QueryClientContext';
import toastHandler from 'Utils/toastHandler';
import { STAGES_QUERY_KEY } from 'Data/keys/QueryKeys';
import { ObrasApiV2 } from 'Data/Obras.api.v2';
import { IStage, IUpdateStageRequest } from 'Data/interfaces/Obra/IObraStages';
import { useDispatch } from 'react-redux';
import { ActivitiesActions } from 'Store/Activities/Activities.actions';

export const useQueryUpdateStages = () => {
  const dispatch = useDispatch();

  const { mutate, isPending } = useMutation({
    mutationFn: (variables: IUpdateStageRequest) => {
      return ObrasApiV2.updateStages(variables);
    },
    onSuccess: async ({ data }, variables) => {
      await queryClient.cancelQueries({
        queryKey: [STAGES_QUERY_KEY, variables.constructionStieId],
      });

      queryClient.setQueryData<IStage[]>(
        [STAGES_QUERY_KEY, variables.constructionStieId],
        (oldData) => {
          return oldData?.map((stage) => {
            if (
              stage.IsDefault &&
              data.data.IsDefault &&
              stage.TopicStageId !== data.data.TopicStageId
            ) {
              stage.IsDefault = false;
            }
            if (stage.TopicStageId === data.data.TopicStageId) {
              return data.data;
            }
            return stage;
          });
        },
      );

      dispatch(
        ActivitiesActions.updateStagesSuccess({
          constructionStieId: variables.constructionStieId,
          stage: data.data,
        }),
      );

      toastHandler.showSuccess('Etapa atualizada com sucesso!');
    },
    onError: (error: any) => {
      const errorMsg = error.errors
        ? error.errors[0].Message
        : 'Erro ao atualizar Etapa!';
      toastHandler.showError(errorMsg);
    },
  });

  return {
    updateStage: mutate,
    isLoading: isPending,
  };
};
